<div *ngIf="display" class="file-container">
    <!-- Image type -->
    <ng-container *ngIf="fileType === 'image'; else nonImageTpl">
        <img loading="lazy" class="image-content" [style.height]="height" [style.width]="width" [src]="safeUrl"
            (error)="onImageError($event)" [alt]="alt">
    </ng-container>

    <!-- Non-image template -->
    <ng-template #nonImageTpl>
        <div class="file-card">
            <div class="file-info">
                <mat-icon [ngClass]="fileType + '-icon'" class="file-icon-display">{{ getIconName() }}</mat-icon>
                <span class="file-name" [title]="getFileName()">{{ getFileName() }}</span>
            </div>
            <button mat-icon-button (click)="downloadFile()" title="Download file" class="download-btn" type="button">
                <mat-icon>cloud_download</mat-icon>
            </button>
        </div>
    </ng-template>
</div>